<p *ngIf="hasError(name)" class="u-text--sm u-text--error u-m-top--tiny">
	<ng-content></ng-content>
</p>
